export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/queries/capital-gains/schema.ts"